module.exports = __webpack_public_path__ + "img/members-icon-dark.ecb6072a.svg";